import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { environment } from "../../../environments/environment";

@Component({
  selector: "other-reports-url-config",
  templateUrl: "./other-reports-url-config.component.html",
  styleUrls: ["./other-reports-url-config.component.scss"],
})
export class OtherReportsUrlConfigComponent implements OnInit {
  @Input() metric;
  @Input() hasChangesToSave;
  @Input() pending;
  @Input() savedSuccessfully;
  @Input() error;
  @Input() isStarter;
  @Output() otherReportsUrlChanged = new EventEmitter();
  @Output() saveOtherReportsUrl = new EventEmitter();
  public hostname = `${environment.szAppHostname}`;
  constructor() {}

  ngOnInit() {}

  testLink() {
    // check for protocol
    window.open(
      !this.metric.otherReportsUrl.match(/^https?:\/\//i)
        ? "http://" + this.metric.otherReportsUrl
        : this.metric.otherReportsUrl,
      "_blank"
    );
  }
}
